module.exports = "/_next/static/images/backup-f1331eaf24ea5dc8d94c02faf5efc099.svg";